import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { academylist, counthostellist, createhostelentry, listhostelentry } from "../../../services/admin";
import { Col, Modal, Row } from "react-bootstrap";
import Select from "react-select";
import { bedtypelist, hostellist, roleList, roomnolist } from "../../../services/master";
import { studenttype } from "../../../services/student";
import { toast } from "react-toastify";
import moment from "moment/moment";

export default function AllhostelStudents() {
  const [filterProduct, setFilterProduct] = useState([]);
  const [chlist, setChlist] = useState([]);
  const [ctlist, setCtlist] = useState([]);
  const [wlist, setWlist] = useState([]);
  const [wtype, setWType] = useState("");


  const columnDefs = [
    {
      headerName: "Hostel",
      width: 170,
      field: "hostel_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Room No",
      width: 170,
      field: "room_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Type",
      width: 150,
      field: "hostel_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Role",
      width: 150,
      field: "role_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      width: 200,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      width: 200,
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Class",
      width: 150,
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      width: 150,
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

  ];
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [cacaid, setCAcaID] = useState("");


  const [hlist, setHList] = useState([]);
  const [roomlist, setRoomList] = useState([]);
  const [htype, setHType] = useState("");
  const [rtype, setRType] = useState("");
  const [roomid, setRoomID] = useState("");
  const [desc, setDesc] = useState("");
  const [hdate, setHDate] = useState("");

  const [slist, setSList] = useState([]);
  const [tlist, setTList] = useState([]);

  const [stype, setSType] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {

    if (localStorage.getItem("ADate") !== '') {
      setHDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
    } else {
      setHDate(moment(new Date()).format("YYYY-MM-DD"));
    }
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    roleList().then((res) => {
      if (res.status === true) {
        setWlist(res.data);
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setCAcaID(arr[0]);
                listall(arr[0], "");
                funlist(arr[0]);
              }
            }

          }
        }
      });
    } else {
      listall("", "");

      funlist("");
    }
  }, [])

  function handleAcademyChange(e) {
    if (e !== null) {
      setCAcaID(e);
      listall(e, htype);
    } else {
      setCAcaID("");
      listall("", "");
    }
  }

  function listall(ltype, lhos) {
    setRType(lhos);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && ltype !== "") {
      temp.append("academy_id", ltype.value);
    }
    temp.append("type", lhos);
    temp.append("status", 1);

    listhostelentry(temp).then((res) => {
      if (res.status === true) {
        // setFilterProduct(res.data);
        const sdata = res.data.map((item) => {
          return {
            ...item,
            role_id: item.role_id === 4 ? "Student" : item.role_id === 5 ? "Teacher" : "",
          };
        });
        setFilterProduct(sdata);
      }
    });

    const temp1 = new FormData();
    if (localStorage.getItem("Role") === "1" && ltype !== "") {
      temp1.append("academy_id", ltype.value);
    }
    counthostellist(temp1).then((res) => {
      if (res.status === true) {
        setChlist(res.data.total_counts);
        setCtlist(res.data.student_and_residing_counts);

      }
    });
  }
  const [show, setShow] = useState(false);
  function handleshow() {
    setShow(true);
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }
           
          }
        }
      });
    }
    setHType("");
    setSType("");
    setDesc("");
    setRoomID("");
    setErrorMessage("");
  }


  function handleclose() {
    setShow(false);
    setAcaID("");
    setHType("");
    setSType("");
    setDesc("");
    setRoomID("");
    setErrorMessage("");
  }


  function handleAcademy(e) {

    if (e !== null) {
      setAcaID(e);
      funlist(e);
    } else {
      setAcaID("");
      funlist("");
    }
  }

  function handleHType(e, aid) {
    setHType(e.target.value)
    setRoomList([]);
    setRoomID("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }

    roomnolist(temp).then((res) => {
      if (res.status === true) {
        const sdata = res.data.filter((item) => item.active == 1 && item.room_hostel == e.target.value);
        if (sdata) {
          setRoomList(sdata);
        }
      }
    });

  }

  function funlist(aid) {
    setHList([]);
    setHType("");
    setSList([]);
    setTList([]);
    setSType("");
    setRoomList([]);
    setRoomID("");
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    hostellist(temp).then((res) => {
      if (res.status === true) {

        const sdata = res.data.filter((item) => item.active == 1);
        if (sdata) {
          setHList(sdata);
        }
      }
    });



    const temp1 = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp1.append("academy_id", aid.value);
    }
    temp1.append("type", 2);
    studenttype(temp1).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].username + " (" + res.data.details[i].student_name + ") - " + res.data.details[i].class_name + " - " + res.data.details[i].section_name + " - " + res.data.details[i].gender,
            });
          }
          setSList(arr);
        }

        let arr1 = [];
        if (res.data.teachers.length > 0) {
          for (let i = 0; i < res.data.teachers.length; i++) {
            arr1.push({
              value: res.data.teachers[i].id,
              label:
                res.data.teachers[i].username + " (" + res.data.teachers[i].teacher_name + ") - " + res.data.teachers[i].class_name + " - " + res.data.teachers[i].section_name + " - " + res.data.teachers[i].gender,
            });
          }
          setTList(arr1);
        }
      }
    })
  }

  function handleStudent(e) {
    if (e !== null) {
      setSType(e);
    } else {
      setSType("");
    }
  }

  function handlesubmit(e) {
    e.preventDefault();
    setErrorMessage("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        valid = "Please Select Academy";
        setErrorMessage(valid);
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (htype !== "") {
        if (roomid !== "") {
          if (stype !== "") {
            if (hdate !== "") {
              const temp = new FormData();
              if (localStorage.getItem("Role") === "1" && acaid !== "") {
                temp.append("academy_id", acaid.value);
              }
              temp.append("hostel_id", htype);
              temp.append("roomnum_id", roomid);
              temp.append("student_id", stype.value);
              temp.append("description", desc);
              temp.append("hostel_date", hdate);
              temp.append("role_id", wtype);

              createhostelentry(temp).then((res) => {
                if (res.status === true) {
                  handleclose();
                  toast.success(res.message);
                  funlist("");
                } else {
                  setErrorMessage(res.message);
                }
              });
            } else {
              setErrorMessage("Please Select Date");
            }

          } else {
            setErrorMessage("Please Select Student");
          }
        } else {
          setErrorMessage("Please Select Room Number");
        }
      } else {
        setErrorMessage("Please Select Hostel");
      }
    }


  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Hostel Students</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Hostel Management </a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            All Hostel Students
          </li>
        </ol>
      </div>
      <div class="row row-sm">
        {chlist.length > 0 &&
          <>
            <div class="col-xl-3 col-md-3">
              <div class="card custom-card">
                <div class="card-bodyy I-st">
                  <div class="row">
                    <div class="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a>{chlist[0].hostel_type} Hostel</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-6 col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{chlist[0].hostel_count} </a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted ">Total Hostel</p>
                    </div>
                  </div>
                  <div className="col-md-6 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{chlist[0].room_count} </a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Total Rooms</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-3">
              <div class="card custom-card">
                <div class="card-bodyy II-st">
                  <div class="row">
                    <div class="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a> {chlist[1].hostel_type}  Hostel</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-6 col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{chlist[1].hostel_count} </a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted ">Total Hostel</p>
                    </div>
                  </div>
                  <div className="col-md-6 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{chlist[1].room_count} </a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Total Rooms</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </>
        }
        {ctlist.length > 0 &&
          <>
            <div class="col-xl-3 col-md-3">
              <div class="card custom-card">
                <div class="card-bodyy IV-st">
                  <div class="row">
                    <div class="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a>{ctlist[0].hostel_type}</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-6 col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{ctlist[0].boys_count}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted ">Total</p>
                    </div>
                  </div>
                  <div className="col-md-6 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{ctlist[0].residing_count}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">  Allotted</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-3">
              <div class="card custom-card">
                <div class="card-bodyy V-st">
                  <div class="row">
                    <div class="col-lg-12">
                      <div className="product-content">
                        <h3 className="title">
                          <a>{ctlist[1].hostel_type}</a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row sales-product-infomation pb-0 mb-0 mx-auto wd-100p">
                  <div className="col-md-6 col justify-content-center text-center">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{ctlist[1].girls_count}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted ">Total</p>
                    </div>
                  </div>
                  <div className="col-md-6 col text-center float-end">
                    <h3 className="mb-1 font-weight-bold">
                      {" "}
                      <a>{ctlist[1].residing_count}</a>{" "}
                    </h3>
                    <div className="d-flex justify-content-center ">
                      <p className="text-muted">Allotted</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }

      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">

              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  All Hostel students List
                </h2>
              </div>
              <div className="row mt-2">
                {localStorage.getItem('Role') == '1' &&
                  <div className="col-xl-4 col-md-4">
                    <label className="main-content-label mb-2">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={cacaid}
                      options={alist}
                      onChange={handleAcademyChange}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                  </div>
                }

                <div className="col-xl-4 col-md-4">
                  <label className="main-content-label mb-2">Select Type</label>
                  <select className="default-select form-control wide" onChange={(e) => listall(cacaid, e.target.value)} value={rtype}>
                    <option value="" disabled selected>
                      Select Type
                    </option>
                    <option value={'Boys'}>Boys</option>
                    <option value={'Girls'}>Girls</option>
                  </select>
                </div>
                {(localStorage.getItem('Role') == '1' || localStorage.getItem('Role') == '2' || localStorage.getItem('Role') == '8') &&
                  <div className="col-xl-4 col-md-4">
                    <div className="text-right">
                      <a className="btn btn-success" onClick={handleshow}>Add Hostel Student</a>
                    </div>
                  </div>
                }
              </div>
              <div className="ag-theme-alpine ag-style mt-3">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show}>
        <Modal.Header>
          <h4>Add Hostel Student</h4>
        </Modal.Header>
        <Modal.Body>
          <Row className="row-sm mx-0">
            {localStorage.getItem("Role") === "1" && (
              <Col lg={12} md={12}>
                <div className="form-label">
                  <label className="mb-2">
                    Select Academy
                    <span className="text-danger"> *</span>

                  </label>
                </div>
                <Select
                  className="default-select"
                  placeholder="Select Academy"
                  value={acaid}
                  options={alist}
                  onChange={handleAcademy}
                  isSearchable={true}
                  isClearable
                  hidden
                />

              </Col>
            )}

            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Hostel <span className="text-danger"> *</span>
                </label>
              </div>
              <div className="form-group">
                <select
                  className="form-control"
                  value={htype}
                  onChange={(e) => handleHType(e, acaid)}
                >
                  <option value="">Select Hostel</option>
                  {hlist.map((item) => {
                    return (
                      <option value={item.id} key={item.id}>{item.name}</option>
                    )
                  }
                  )}
                </select>
              </div>
            </Col>

            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Room Number <span className="text-danger"> *</span>
                </label>
              </div>
              <div className="form-group">
                <select
                  className="form-control"
                  value={roomid}
                  onChange={(e) => setRoomID(e.target.value)}
                >
                  <option value="">Select Room Number</option>
                  {roomlist.map((item) => {
                    return (
                      <option value={item.id} key={item.id}>{item.room_no} - {item.bedtype_name}</option>
                    )
                  })}
                </select>
              </div>
            </Col>

            <Col lg={12} md={12}>
              <div className="mb-3">
                <label className="form-label">
                  Role Type
                  <span className="text-danger"> *</span>
                </label>
                <select
                  className="default-select form-control wide"
                  value={wtype}
                  onChange={(e) => setWType(e.target.value)}
                >
                  <option value="" disabled>
                    Select Role Type
                  </option>
                  {wlist
                    .filter(item => item.id > 2 && item.id < 6)
                    .map((item) => {
                      return (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      );
                    })}

                </select>

              </div>
            </Col>
            {wtype == 4 &&
              <Col lg={12} md={12}>
                <div className="form-label">
                  <label className="mb-2">
                    Select Student
                    <span className="text-danger"> *</span>

                  </label>
                </div>
                <Select
                  className="default-select"
                  placeholder="Select Student"
                  value={stype}
                  options={slist}
                  onChange={handleStudent}
                  isSearchable={true}
                  isClearable
                  hidden
                />

              </Col>
            }
            {wtype == 5 &&
              <Col lg={12} md={12}>
                <div className="form-label">
                  <label className="mb-2">
                    Select Teacher
                    <span className="text-danger"> *</span>

                  </label>
                </div>
                <Select
                  className="default-select"
                  placeholder="Select Teacher"
                  value={stype}
                  options={tlist}
                  onChange={handleStudent}
                  isSearchable={true}
                  isClearable
                  hidden
                />

              </Col>
            }



            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Date<span className="text-danger"> *</span>
                </label>
              </div>
              <div className="form-group">
                <input
                  type="date"
                  value={hdate}
                  onChange={(e) => setHDate(e.target.value)}
                />
              </div>
            </Col>
            <Col lg={12} md={12}>
              <div className="form-group">
                <label className="mb-2">
                  Description
                </label>
              </div>
              <div className="form-group">
                <textarea
                  rows="3"
                  placeholder="Enter Your Description"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </div>
            </Col>
            {errorMessage !== "" && (
              <span className="text-danger">{errorMessage}</span>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-next btn-success"
            style={{ float: "right" }}
            onClick={handlesubmit}
          >
            Submit
          </a>

          <a
            className="btn btn-next btn-secondary"
            style={{ float: "right" }}
            onClick={handleclose}
          >
            Close
          </a>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
